export default "__VITE_ASSET__BIqMSloP__"